export function jsonDeepClone(value: any): any {
  if (value) {
    return JSON.parse(JSON.stringify(value), dateReviver);
  }
  return value;
}

export function dateReviver(key: string, value: string) {
  const dateFormat = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d*)?Z?$/;
  if (typeof value === 'string' && dateFormat.test(value)) {
    if ((value as string).endsWith('Z')) {
      value = value.slice(0, -1);
    }
    return new Date(value);
  }
  return value;
}
